import Main from './Main'
import Motd from './Motd'

export default {
  Main,
  Motd
}



// WEBPACK FOOTER //
// ./src/components/Settings/index.js